const module = { name: 'theater/shared/tdpLocationHelper', exports: {} }; const exports = module.exports;



import { fd_url_manager as links } from 'require-core';



import { fd_location as fd_location_getLocation } from 'require-global';

const { getLocation } = fd_location_getLocation;


import { default as theater_shared_locationHelpers_getLocationFromURL } from 'swug-fdRequire-call:theater/shared/locationHelpers';

const { getLocationFromURL } = theater_shared_locationHelpers_getLocationFromURL;


import { Fandango_geolocator as geolocator } from 'require-global';



import { Fandango as Fandango_pageDetails } from 'require-core';

const { pageDetails } = Fandango_pageDetails;


import { default as shared_utils_urlHelpers_generateTspLink } from 'swug-fdRequire-call:shared/utils/urlHelpers';

const { generateTspLink } = shared_utils_urlHelpers_generateTspLink;


const RegExes = {
    SPACES: /\s+/g,
    CITY_ST: /^(.*),\s*(\w+)$/,
}
function getLocationSlugged() {
    const location = getLocation();
    if (!location) {
        return null;
    }
    const { postalCode, city, region, country } = location;
    if (country && country !== 'US') {
        if (postalCode) {
            return `${postalCode.replace(RegExes.SPACES, '-')}_${country}`.toLowerCase();
        }
        if (city && region) {
            return `${city.replace(RegExes.SPACES, '-')}_${region.replace(RegExes.SPACES, '-')}_${country}`.toLowerCase();
        }
    }
    if (postalCode) {
        return postalCode;
    }
    if (city && region) {
        return `${city.replace(RegExes.SPACES, '-')}_${region}`.toLowerCase();
    }
    return null;
}
function getShowtimesURL(defaultURL) {
    const location = getLocationSlugged();
    if (location) {
        return generateTspLink(location);
    }
    return defaultURL || links.tspMovieTimes();
}
function updateLocationURL() {
    const newUrl = getShowtimesURL();
    if (newUrl && newUrl !== window.location.pathname) {
        history.replaceState(null, '', newUrl);
    }
}
function resolveUrlLocation(cb) {
    if (!pageDetails.useUrlLocation) {
        return cb();
    }
    const urlLocation = getLocationFromURL(window.location.pathname);
    const currentLocation = getLocation();
    if (!urlLocation.postalCode && !urlLocation.city) {
        return cb();
    }
    const urlPostal = urlLocation.postalCode ? urlLocation.postalCode.toUpperCase() : null;
    const currentPostal = currentLocation.postalCode ? currentLocation.postalCode.toUpperCase() : null;
    if (urlPostal && currentPostal === urlPostal) {
        return cb();
    }
    const urlCity = urlLocation.city ? urlLocation.city.toLowerCase() : null;
    const currentCity = currentLocation.city ? currentLocation.city.toLowerCase() : null;
    const urlRegion = urlLocation.region ? urlLocation.region.toUpperCase() : null;
    const currentRegion = currentLocation.region ? currentLocation.region.toUpperCase() : null;
    if (urlCity && currentCity === urlCity && urlRegion && currentRegion === urlRegion) {
        return cb();
    }
    let locationString;
    const options = {};
    if (urlLocation.city && urlLocation.region) {
        locationString = `${urlLocation.city}, ${urlLocation.region.toUpperCase()}`;
    }
    else if (urlLocation.postalCode) {
        locationString = urlLocation.postalCode;
        if (urlLocation.country) {
            options.countryCode = urlLocation.country;
        }
    }
    else {
        return cb();
    }
    geolocator.setUserLocationCookie(locationString, (err) => {
        if (!err) {
            Object.assign(pageDetails, { location: getLocation() });
        }
        cb();
    }, Object.assign({}, options, { skipMismatchCheck: true, supportedCountries: ['GB', 'IE', 'US'] }));
}
module.exports = {
    getLocationSlugged,
    getShowtimesURL,
    resolveUrlLocation,
    updateLocationURL,
};
export default module.exports;